import { getTheme } from "@clipboard-health/ui-theme";
import { ThemeProvider } from "@mui/material";
import { ModalRoute } from "@src/appV2/redesign/Navigation/ModalRoute";
import { ModalTransitionSwitch } from "@src/appV2/redesign/Navigation/ModalTransitionSwitch";
import { useRouteMatch } from "react-router-dom";

import { useWorkerEtaImprovementsConfig } from "../../ClipboardScore/hooks/useWorkerEtaImprovementsConfig";
import { OpenGeoLocationBottomSheet } from "../../OpenGeoLocation/OpenGeoLocationBottomSheet";
import { UpdateEtaConfirmedBottomSheetContainer } from "../../Shift/WorkerEta/UpdateEta/Confirmed/Container";
import { UpdateEtaBottomSheetContainer } from "../../Shift/WorkerEta/UpdateEta/Container";
import {
  SHIFT_DETAILS_ATTENDANCE_CONFIRMED_PATH,
  SHIFT_DETAILS_OPEN_GEOLOCATION_PATH,
  SHIFT_DETAILS_UPDATE_ETA_CONFIRMED_PATH,
  SHIFT_DETAILS_UPDATE_ETA_PATH,
} from "../path";
import { AttendanceConfirmedBottomSheet } from "./components/AttendanceConfirmedBottomSheet";
import { UpdateEtaBottomSheet } from "./components/UpdateEtaBottomSheet";

export function ShiftDetailsModalRoutes(props: { shiftId: string }) {
  const { shiftId } = props;
  const match = useRouteMatch();
  const { enabled: isWorkerEtaImprovementsEnabled } = useWorkerEtaImprovementsConfig();

  return (
    <ThemeProvider theme={getTheme()}>
      <ModalTransitionSwitch>
        <ModalRoute
          exact
          shouldReplacePathOnBack
          closeModalPath={match.url}
          path={`${match.url}${SHIFT_DETAILS_UPDATE_ETA_PATH}`}
          render={({ modalState }) =>
            isWorkerEtaImprovementsEnabled ? (
              <UpdateEtaBottomSheetContainer modalState={modalState} shiftId={shiftId} />
            ) : (
              <UpdateEtaBottomSheet modalState={modalState} shiftId={shiftId} />
            )
          }
        />

        <ModalRoute
          exact
          shouldReplacePathOnBack
          closeModalPath={match.url}
          path={`${match.url}${SHIFT_DETAILS_UPDATE_ETA_CONFIRMED_PATH}`}
          render={({ modalState }) => (
            <UpdateEtaConfirmedBottomSheetContainer modalState={modalState} shiftId={shiftId} />
          )}
        />

        <ModalRoute
          shouldReplacePathOnBack
          closeModalPath={match.url}
          path={`${match.url}${SHIFT_DETAILS_OPEN_GEOLOCATION_PATH}`}
          render={({ modalState }) => <OpenGeoLocationBottomSheet modalState={modalState} />}
        />

        <ModalRoute
          shouldReplacePathOnBack
          closeModalPath={match.url}
          path={`${match.url}${SHIFT_DETAILS_ATTENDANCE_CONFIRMED_PATH}`}
          render={({ modalState }) => <AttendanceConfirmedBottomSheet modalState={modalState} />}
        />
      </ModalTransitionSwitch>
    </ThemeProvider>
  );
}
